import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./components/App";
import {
  BrowserRouter ,
} from "react-router-dom";
import "./index.css";
import { store } from "./store";

ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
          {/* <body className="bg-white dark:bg-custom"> */}
            <App />
            {/* <div className="bg-white dark:bg-custom">

            </div>
          </body> */}
    </BrowserRouter>
     
    </Provider>
  // </React.StrictMode>
  ,
  document.getElementById("root")
);
